import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
import { usePageTitle } from '../hooks/usePageTitle';

const PrivacyPage = () => {
    usePageTitle('Privacy Policy');
  return (
    <>
      <section className="page-header">
        <h1>🔒 PRIVACY POLICY 🔒</h1>
        <p style={{ color: '#66ff66', fontSize: '1.2rem' }}>
          Your privacy matters to us
        </p>
        <Link to="/" className="back-button">
          ← BACK TO HOME
        </Link>
      </section>

      <div className="content-container">
        <div className="privacy-box">

          <div className="highlight-box"
            style={{ background: 'rgba(0, 255, 0, 0.1)', border: '2px solid #00ff00' }}>
            <p><strong>✅ YOUR PRIVACY IS IMPORTANT</strong></p>
            <p>
              polira.site is committed to protecting your privacy. This policy explains how we handle your information when you use our platform.
            </p>
          </div>

          <h2>1. INFORMATION WE COLLECT</h2>
          <p>
            Since polira.site is a platform with no registration or accounts, we collect minimal information:
          </p>
          <ul>
            <li><strong>Technical Data:</strong> Browser type, device information, and IP address for security purposes</li>
            <li><strong>Usage Data:</strong> Pages visited and features used to improve our service</li>
            <li><strong>Contact Information:</strong> Only if you voluntarily contact us via email</li>
          </ul>
          <p>
            <strong>We do NOT collect:</strong> Personal identification, financial information, or any payment details (as we don't accept money).
          </p>

          <h2>2. HOW WE USE YOUR INFORMATION</h2>
          <p>Any information we collect is used solely to:</p>
          <ul>
            <li>Provide and maintain the platform</li>
            <li>Improve user experience</li>
            <li>Respond to your inquiries</li>
            <li>Ensure platform security</li>
            <li>Analyze usage patterns to enhance features</li>
          </ul>

          <h2>3. COOKIES AND TRACKING</h2>
          <p>
            We may use basic cookies to enhance your browsing experience. These cookies do not store personal information and are used solely for:
          </p>
          <ul>
            <li>Remembering your preferences</li>
            <li>Analyzing site traffic</li>
            <li>Improving platform functionality</li>
          </ul>
          <p>
            You can disable cookies in your browser settings, though this may affect some platform features.
          </p>

          <h2>4. DATA SHARING</h2>
          <p>
            We do NOT sell, trade, or rent your information to third parties. We may share information only in these circumstances:
          </p>
          <ul>
            <li>When required by law or legal process</li>
            <li>To protect our rights and safety</li>
            <li>With service providers who help operate our platform (under strict confidentiality)</li>
          </ul>

          <h2>5. DATA SECURITY</h2>
          <p>
            We implement reasonable security measures to protect your information. However, no internet transmission is 100% secure, and we cannot guarantee absolute security.
          </p>

          <h2>6. THIRD-PARTY LINKS</h2>
          <p>
            Our platform may contain links to external websites. We are not responsible for the privacy practices of these sites. Please review their privacy policies before providing any information.
          </p>

          <h2>7. CHILDREN'S PRIVACY</h2>
          <p>
            Our platform is intended for users 18 years and older. We do not knowingly collect information from minors. If you believe we have inadvertently collected data from a minor, please contact us immediately.
          </p>

          <h2>8. YOUR RIGHTS</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access any information we hold about you</li>
            <li>Request correction of inaccurate data</li>
            <li>Request deletion of your data</li>
            <li>Opt-out of communications</li>
            <li>Lodge a complaint with data protection authorities</li>
          </ul>

          <h2>9. DATA RETENTION</h2>
          <p>
            We retain information only as long as necessary to provide our services and comply with legal obligations. Usage data is typically retained for a limited period for analytical purposes.
          </p>

          <h2>10. INTERNATIONAL USERS</h2>
          <p>
            Our platform may be accessed globally. By using polira.site, you consent to the transfer of information to locations that may have different data protection laws than your country.
          </p>

          <h2>11. CHANGES TO THIS POLICY</h2>
          <p>
            We may update this Privacy Policy periodically. Changes will be posted on this page with an updated revision date. Continued use of the platform after changes constitutes acceptance of the new policy.
          </p>

          <h2>12. CONTACT US</h2>
          <p>
            If you have questions about this Privacy Policy or how we handle your information, please contact us:
          </p>
          <p>
            Email: <a href="mailto:support@hrtechit.com" style={{ color: '#00ff00' }}>support@hrtechit.com</a>
          </p>

          <div className="last-updated">
            <p>Last Updated: December 2025</p>
            <p>Effective Date: December 2025</p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PrivacyPage;

